<template>
  <div class="login-screen">
    <v-card width="420" variant="flat">
      <v-card-title>Вход</v-card-title>
      <v-card-text class="form-grid">
        <v-text-field v-model="loginValue" label="Логин" autocomplete="username" />
        <v-text-field v-model="password" label="Пароль" type="password" autocomplete="current-password" @keyup.enter="submit" />
        <v-alert v-if="error" type="error" variant="tonal">{{ error }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" prepend-icon="mdi-login" @click="submit">Войти</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { login } from '../api/http';
const router = useRouter();
const loginValue = ref('');
const password = ref('');
const error = ref('');
async function submit() {
  error.value = '';
  try {
    await login(loginValue.value, password.value);
    router.push('/dashboard');
  } catch (e) {
    error.value = e.response?.data?.message || e.message;
  }
}
</script>
